import { writable } from 'svelte/store';

export type Toast = {
  id: number;
  type: 'success' | 'error';
  message: string;
  timeout: number;
};
export const toasts = writable<Toast[]>([]);

export const addToast = (toast: Partial<Toast> & { message: string }) => {
  const newToast: Toast = {
    id: Date.now() + Math.floor(Math.random() * 10_000),
    type: 'success',
    timeout: 3000,
    ...toast,
  };
  toasts.update((all) => [newToast, ...all]);

  setTimeout(() => {
    removeToast(newToast.id);
  }, newToast.timeout);
};

export const removeToast = (id: number) => {
  toasts.update((all) => all.filter((t) => t.id !== id));
};
